import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { PreparationBasic } from 'src/app/models/catalogs-model/preparation.model';
import { ProductBasic } from 'src/app/models/catalogs-model/product.model';
import { Subscription } from 'rxjs/internal/Subscription';
import { ProductsService } from 'src/app/services/catalogs-services/products-services/products.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';

@Component({
  selector: 'app-catalogs-product-preparations-card',
  templateUrl: './catalogs-product-preparations-card.component.html',
  styleUrls: ['./catalogs-product-preparations-card.component.scss']
})
export class CatalogsProductPreparationsCardComponent implements OnInit, OnDestroy {

  @Input() product: ProductBasic;
  @Input() preparations: Array<PreparationBasic>;
  selectedPreparations;
  updateProductPreparationsSubscription: Subscription;

  constructor(private productsService: ProductsService,
              private userStorageService: UserStorageService,
              private snackbarService: SnackBarService) { }

  ngOnInit() { }

  public duallistboxOutputEventReceiver(selectedDevices) {
    const aux = new Array();
    for (const d of selectedDevices) {
      aux.push(d[1]._data);
    }
    if (aux) {
      this.selectedPreparations = aux;
      this.updateProductPreparations();
    }
  }

  public updateProductPreparations() {
    this.updateProductPreparationsSubscription = this.productsService.updateProductPreparations(this.product.InternalId, this.selectedPreparations).subscribe(
      (res) => {
        this.productsService.refreshProduct();
        this.snackbarService.open('catalogs-page.snackbar messages.update product success', 'success');
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  ngOnDestroy() {
    if (this.updateProductPreparationsSubscription) { this.updateProductPreparationsSubscription.unsubscribe(); }
  }

}
